<template>
      <core-layout-headline-with-tabs :tabs="tabs">{{ $t("client") }}</core-layout-headline-with-tabs>
</template>

<script>
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs"

export default {
	components: { CoreLayoutHeadlineWithTabs },

	computed: {
		tabs() {
			// TODO: hacky, needs to be refactored once we move clients completely into modules
			return [
				// {
				// 	id: "overview",
				// 	name: this.$t("overview"),
				// 	to: `/${
				// 		this.$route.params.tenantId
				// 	}/clients/detail/${
				// 		this.$route.params.id
				// 	}/overview/${this.$route.params.clientType}`
				// },
				{
					id: "overview",
					name: this.$t("overview"),
					to: `/${
						this.$route.params.tenantId
					}/clients/detail/${
						this.$route.params.id
					}/overview/${this.$route.params.clientType}`
				},
				{
					id: "policies",
					name: `${this.$t("policies")}`,
					to: `/${
						this.$route.params.tenantId
					}/clients/detail/${
						this.$route.params.id
					}/policies/${this.$route.params.clientType}`
				},
				{
					id: "objects",
					name: `${this.$t("objects")}`,
					to: `/${
						this.$route.params.tenantId
					}/clients/detail/${
						this.$route.params.id
					}/objects/${this.$route.params.clientType}`
				},

				{
					id: "logs",
					name: `${this.$t("logs")}`,
					to: `/${
						this.$route.params.tenantId
					}/clients/detail/${this.$route.params.id}/logs/${
						this.$route.params.clientType
					}`
				}
			]
		}
	}
}
</script>
